import React, { useState } from 'react';
import { Button, Drawer, Input } from 'antd';
import { CloseOutlined, RightOutlined } from '@ant-design/icons';
import { CUSTOM_INSTRUCTION_MAX_LENGTH } from '../../../../domain/models/AiReceptionist';

interface AdditionalInstructionsSectionProps {
  assistantName: string;
  value: string;
  onChange: (value: string) => void;
}

const AdditionalInstructionsSection: React.FC<AdditionalInstructionsSectionProps> = ({
  assistantName,
  value,
  onChange,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const name = assistantName || 'Donna';

  const openEditor = () => {
    setDraft(value);
    setIsEditing(true);
  };

  const confirmEditor = () => {
    onChange(draft);
    setIsEditing(false);
  };

  return (
    <>
      <p className="receptionist-ai-detail-page__section-subtitle">
        Ce que {name} doit faire sur tous les appels, en plus des motifs. Ça ne remplace rien : ce qu’elle fait pour
        chaque motif et la façon dont elle conclut ne changent pas.
      </p>

      <div className="receptionist-ai-detail-page__instructions-box">
        <button type="button" className="receptionist-ai-detail-page__motif-row" onClick={openEditor}>
          <span className="receptionist-ai-detail-page__motif-text">
            <span className="receptionist-ai-detail-page__motif-title">Pour tous les appels</span>
            {value ? (
              <span className="receptionist-ai-detail-page__instructions-value">« {value} »</span>
            ) : (
              <span className="receptionist-ai-detail-page__motif-subtitle">Aucune consigne pour l’instant.</span>
            )}
          </span>
          <span className="receptionist-ai-detail-page__edit-link">Modifier</span>
          <RightOutlined className="receptionist-ai-detail-page__motif-chevron" />
        </button>
      </div>

      <Drawer
        title="Consignes additionnelles"
        open={isEditing}
        onClose={() => setIsEditing(false)}
        width={440}
        closable={false}
        extra={<Button type="text" icon={<CloseOutlined />} onClick={() => setIsEditing(false)} />}
        footer={
          <div className="receptionist-ai-detail-page__drawer-footer">
            <Button onClick={() => setIsEditing(false)}>Annuler</Button>
            <Button type="primary" onClick={confirmEditor}>
              Enregistrer
            </Button>
          </div>
        }
      >
        <p className="receptionist-ai-detail-page__section-subtitle">
          Pour tous les appels, en plus de ce que {name} fait pour chaque motif.
        </p>

        <label className="receptionist-ai-detail-page__drawer-label" htmlFor="receptionist-ai-instructions">
          Ce que {name} doit faire sur tous les appels, avec vos mots
        </label>
        <Input.TextArea
          id="receptionist-ai-instructions"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          maxLength={CUSTOM_INSTRUCTION_MAX_LENGTH}
          rows={6}
        />
        <div className="receptionist-ai-detail-page__field-footer">
          <p className="receptionist-ai-detail-page__hint">
            En plus des motifs, jamais à leur place. Ce que {name} fait pour chaque motif ne change pas.
          </p>
          <span className="receptionist-ai-detail-page__count">
            {draft.length} / {CUSTOM_INSTRUCTION_MAX_LENGTH}
          </span>
        </div>
        <p className="receptionist-ai-detail-page__example">
          <strong>Exemple</strong> — Demande toujours si l’appel concerne un bien précis et, si oui, lequel et avec quel
          conseiller la personne est en contact.
        </p>
      </Drawer>
    </>
  );
};

export default AdditionalInstructionsSection;
